$("form.collection-ATC").submit(function(e){
    e.preventDefault()
    let form = $(this)
    let formData = $(this).serialize();
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: formData,
        success: function (data) {
            jQuery.getJSON('/cart.js', function(cart) {
              
            });
          // This is event for sidecart
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data, //replace this variable with response
            // addToCartBtn: this.addToCart
          }
        }));
        },
        error: function (err) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));
        }
    });
  });

  // --------------------------Country Code display --------------------

        document.addEventListener('DOMContentLoaded', function() {
            fetch("https://ipwho.is/")
                .then(res => res.json())
                .then(data => {
                    const countryCode = data.country_code.toLowerCase();
                    const countryName = data.country;
                    
                    // Update country name and code
                    document.getElementById("country-name").textContent = countryName;
                    document.getElementById("country-code").textContent = data.country_code;
                    document.getElementById("country-code-2").textContent = data.country_code;
                })
                .catch(err => {
                    console.error("Geo lookup failed", err);
                    document.getElementById("country-name").textContent = 'Unknown';
                    document.getElementById("country-code").textContent = 'N/A';
                });
        });